export class Country {
  id: number;
  name: string;
  code: string;
  version: string;
  lastTest: Date;
}
